import classnames from 'classnames';

import styles from './core-entity-sidebar.module.css';

type Props = {
    children: React.ReactNode;
    hasScrolledPastCheckpoint: boolean;
    hasFullHeightSidebar?: boolean;
};

export function CoreEntitySidebar(props: Props) {
    const {hasFullHeightSidebar, hasScrolledPastCheckpoint} = props;

    return (
        <div
            className={classnames(styles.sidebar, {
                [styles['sidebar--sticky']]: !hasFullHeightSidebar && hasScrolledPastCheckpoint,
                [styles['sidebar--full-height']]: hasFullHeightSidebar,
            })}
        >
            {props.children}
        </div>
    );
}
